import { fork, call, put, select, takeLatest } from 'redux-saga/effects'
import { SET_NAVIGATION, setNavigationDate, configureNavigation } from 'containers/Navigation/actions'
import { selectNavigationRange } from 'containers/Navigation/selectors'
import { TYPE_MONTH_TO_DATE } from 'containers/Navigation/const'
import { LOCATIONS_CHANGED } from 'containers/Locations/actions'
import { selectVisibleLocationIds } from 'containers/Locations/selectors'
import Actions, { startInit, finishInit, receiveProfiles, receiveReports } from './actions'
import { selectToken, selectTimezone, selectVisibleProfiles } from './selectors'
import moment from 'moment-timezone'
import api from 'lib/api/client'
import heartbeat from 'lib/saga/heartbeat'
import locationsSaga from 'containers/Locations/saga'

function * init () {
  const token = yield select(selectToken)
  const timezone = yield select(selectTimezone)

  yield put(startInit())

  yield put(configureNavigation(TYPE_MONTH_TO_DATE))
  yield put(setNavigationDate(moment.tz({ hour: 0 }, timezone)))

  yield call(locationsSaga, token)

  yield put(finishInit())
}

function * profiles () {
  const token = yield select(selectToken)
  const date = yield select(selectNavigationRange)
  const locationIds = yield select(selectVisibleLocationIds)
  const profiles = yield call(api.get, 'products/profiles_in_period', { token, params: { ...date, locationIds } })

  yield put(receiveProfiles(profiles))
}

function * reports () {
  const token = yield select(selectToken)
  const date = yield select(selectNavigationRange)
  const locationIds = yield select(selectVisibleLocationIds)
  const profiles = yield select(selectVisibleProfiles)
  let data = []

  if (locationIds.length > 0 && profiles.length > 0) {
    data = yield call(api.get, 'reports/monthly_evaluation', { token, params: { ...date, locationIds, profiles } })
  }

  yield put(receiveReports(data))
}

export default function * root () {
  if (process.env.NODE_ENV === 'development') {
    yield fork(heartbeat, 'Reports:MonthlyEvaluation')
  }

  yield call(init)
  yield call(profiles)
  yield call(reports)

  yield takeLatest([
    Actions.RECEIVE_PROFILES,
    Actions.SHOW_PROFILE,
    Actions.HIDE_PROFILE,
    Actions.SHOW_ALL_PROFILES,
    Actions.HIDE_ALL_PROFILES
  ], reports)

  yield takeLatest([
    SET_NAVIGATION,
    ...LOCATIONS_CHANGED
  ], profiles)
}
